import Box from '@/components/UI/box/Box';
import dynamic from 'next/dynamic';
import { Dispatch, SetStateAction } from 'react';
import MapLoading from '../reusable/mapLoading/MapLoading';
import { ProductListRecord } from '@/components/reusable/productCard/types';
interface DesktopMapProps {
  data: ProductListRecord[];
  loading: boolean;
  setMapFullscreen: Dispatch<SetStateAction<boolean>>;
  mapFullscreen: boolean;
}
const Map = dynamic(() => import('@/components/reusable/map/Map'), {
  ssr: false,
  loading: () => <Box style={{
    height: '90vh'
  }}>
      <MapLoading />
    </Box>
});
const DesktopMap = ({
  data,
  loading,
  setMapFullscreen,
  mapFullscreen
}: DesktopMapProps) => {
  return <Box data-sentry-element="Box" data-sentry-component="DesktopMap" data-sentry-source-file="DesktopMap.tsx">
      <Map houses={data} loading={loading} setFullscreen={setMapFullscreen} fullscreen={mapFullscreen} data-sentry-element="Map" data-sentry-source-file="DesktopMap.tsx" />
    </Box>;
};
export default DesktopMap;